import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.8898 2.11019L16.4201 1.57986V1.57986L15.8898 2.11019ZM4.41667 16.5296V17.2796C4.61558 17.2796 4.80634 17.2005 4.947 17.0599L4.41667 16.5296ZM1.5 16.5296H0.75C0.75 16.9438 1.08579 17.2796 1.5 17.2796L1.5 16.5296ZM1.5 13.5537L0.96967 13.0233C0.829018 13.164 0.75 13.3548 0.75 13.5537H1.5ZM13.4738 2.64052C13.9945 2.11983 14.8387 2.11983 15.3594 2.64052L16.4201 1.57986C15.3136 0.473379 13.5196 0.473379 12.4132 1.57986L13.4738 2.64052ZM15.3594 2.64052C15.8801 3.16122 15.8801 4.00544 15.3594 4.52614L16.4201 5.5868C17.5266 4.48032 17.5266 2.68635 16.4201 1.57986L15.3594 2.64052ZM15.3594 4.52614L3.88634 15.9992L4.947 17.0599L16.4201 5.5868L15.3594 4.52614ZM4.41667 15.7796H1.5V17.2796H4.41667V15.7796ZM12.4132 1.57986L0.96967 13.0233L2.03033 14.084L13.4738 2.64052L12.4132 1.57986ZM0.75 13.5537V16.5296H2.25V13.5537H0.75ZM11.1632 3.89052L14.1094 6.8368L15.1701 5.77614L12.2238 2.82986L11.1632 3.89052Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }